export const ApiResult = {
    Success: 0,
    Error: 1
};

export const FOR_CONFIRMATION = "Confirmation";

export const NoImageFileUrl = "/img/big%20bell/noimage.jpg";

export const LanguageEN = 9;
export const LanguageJP = 127;

export const DateTimeFormat = "YYYY/MM/DD HH:mm:ss";
export const DateTimeFormatNoSS = "YYYY/MM/DD HH:mm";
export const DateTimeFormat2 = "YYYYMMDDHHmmss";
export const DateFormat = "YYYY/MM/DD";
export const ZAIKOYMFormat = "YYYYMM";
export const YearMonthFormat = "YYYY/MM";

export const CSVDateFormat = "YYYYMMDDHHmmssSSS";
export const CSVDateFormat2 = "YYYYMMDD";

export const OrientationX = "horizontal";
export const AdminNinushi = "0";

export const PARAM = {
    IRAINO: "i"
}

export const ControlKBN = {
    DISABLED: 0,
    ENABLED: 1,
    ADMIN: 2
};

export const ShukaKBN = {
    NORMAL: '1',
    REGULAR: '2',
}
export const UserTYPE = {
    GENERAL: '1',
    POWERUSER: '2',
    ADMINISTRATOR: '3',
}

export const UkeDenKBN = {
    HAIKI: "04",
    IDOU: "05",
    IDOUTORIKESHI: "25"
}

export const InputTYPE = {
    LABEL: "label",
    NUMBER: "number",
    TEXTAREA: "textarea",
    PASSWORD: "password"
}

export const SessionData = {
    NEWIRAIFORM: "newiraiform",
    NEWVHANSOKULIST: "newhansokulist",
    NEWIRAINO: "newiraino",

    UPDIRAINO: "updateiraino",
    UPDIRAIFORM: "updateiraiform",
    UPDVHANSOKULIST: "updatehansokulist",

    DELIRAINO: "deleteiraino",
    DELIRAIFORM: "deleteiraiform",
    DELVHANSOKULIST: "deletehansokulist",

    FAREREGISTRATIONFROMLIST: "fareregistration_list",
    FAREREGISTRATION: "fareregistration_shukadenno",
    FAREREGISTRATIONSHUKANOLIST: "fareregistration_shukanolist",
    BACKZAIKOMANAGEMENT: "backzaikomanagement",

    PODTASKREGISTRATION: "pod_task_registration_shukadenno",
    PODTASKREGISTRATIONFROMLIST: "pod_task_registration_list",

    MASTERHANSOKUSEARCH: "masterhansokusearch",
    HANSOKUDETAIL: "hansokudetail",
    SHIPMENTSEARCH: "shipmentsearch",
    SHIPMENTSLIPSEARCH: "shipmentslipsearch",
    INVENTORYPAYMENT: "inventorypayment",
    ADMINAUTH: "adminAuth",

    ACCOUNTMESSAGE: "accountmessage",
    TODOKESAKIMESSAGE: "todokesakimessage",
    PREVSCREEN: "prevscreen",

    UKEDENKBN: "ukedenkbn",

    FACILITYINFO: "facilityinfo"
};

export const BunruiKBN = {
    BUNRUI1: "bunrui1",
    BUNRUI2: "bunrui2",
    BUNRUI3: "bunrui3"
};

export const UnchinKBN = {
    TSUJO: "1", // Normal
    ROSEN: "2", // Route
    JISHA: "3", // In-house
};

export const PDFTemplate = {
    ADP0001Shuka: "ADP0001",
    ADP0002: "ADP0002",
    ADP0003: "ADP0003",
    ADP0004: "ADP0004",
    ADP0005: "ADP0005",
    ADP0011: "ADP0011",
    ADP0012: "ADP0012",
    ADP0013: "ADP0013",
    ASP0101: "ASP0101",
    ADP0101: "ADP0101",
    ASK0001: "ASK0001",
    ASK0002: "ASK0002",

    AZA0001: "AZA0001",
    AZA0002: "AZA0002",
    AZA0003: "AZA0003",
}

export const ComparisonResult = {
    ALL: "all",
    ALLWITHDIFFERENCES: "all_with_differences",
    NOBILLINGDATA: "no_billing_data",
    NOREGISTEREDDATA: "no_registered_data"
}

export const HolidayKBN = {
    HOLIDAY: "1",
    COMPANYHOLIDAY: "2"
};

export const AggregationUNIT = {
    MONTH: "month",
    DAY: "day"
}

export const RadioSelection = {
    ALL: null,
    SELECTED: true,
    UNSELECTED: false
}

export const OrderByField = {
    CATEGORY: "BunruiCode1",
    HANSOKUCODE: "HansokuCode",
    NYUKADT: "NyukaDt"
}

export const SortOrder = {
    ASC: 0,
    DESC: 1,
}

export const StopFlg = {
    ACCEPTING: 0,
    STOPPED: 1,
    CONFIRMED: 2
}

export const SortOption = {
    LOCATION: 0,
    HANSOKUCODE: 1
}

export const ValidFlag = {
    UNUSED: 0,
    VALID: 1,
    USED: 2,
}

export const LinkStatus = {
    UNFINISHED: 0,
    DONE: 1,
    ALL: 9
}

export const LinkDelFlg = {
    NORMAL: 0,
    CANCELLED: 1
}

export const WaybillCheckFilter =
{
    All: 1,
    HasMismatch: 2,
    CsvHasLacking: 3,
    DbHasLacking: 4
}

export const WaybillCheckFilterString =
{
    All: "◯",
    HasMismatch: "金額不整合",
    CsvHasLacking: "請求データ無し",
    DbHasLacking: "登録データ無し"
}

export const ShipmentSlipNavigation = 
{
    NEXT: "next",
    PREV: "prev"
}

export const TargetMaster = {
    Sagawa: "U1",
    Yamato: "U8"
}

export const DetailScreenType={
    ADD: "1",
    EDIT: "2"
}


// WEBPACK FOOTER //
// ./helpers/const.js